import { FilterKeys, TransactionType } from "@/types/enums/TransactionType";

export const filterKeysMap: Record<FilterKeys, TransactionType[]> = {
  [FilterKeys.ALL_TRANSACTIONS]: [
    TransactionType.AUTOIMPORT,
    TransactionType.BUY_SELL,
    TransactionType.INHERITANCE,
    TransactionType.GIFT,
    TransactionType.ISSUE,
    TransactionType.INCORPORATION,
    TransactionType.INCREASE_NOMINAL_VALUE,
    TransactionType.SPLIT,
    TransactionType.REVERSE_SPLIT,
    TransactionType.REDUCTION_NOMINAL_VALUE,
    TransactionType.CANCELLATION_OF_SHARES,
    TransactionType.PAY_DIVIDEND,
    TransactionType.GROUP_CONTRIBUTION,
    TransactionType.CONVERSION_OF_SHARES,
    TransactionType.CONVERSION_FROM_ISIN,
    TransactionType.SHAREHOLDING_PER_DATE,
    TransactionType.OWNERS_PER_DATE,
    TransactionType.LIQUIDATION,
    TransactionType.MERGER,
    TransactionType.OTHER_TRANSFER,
    TransactionType.DEMERGER,
    TransactionType.COMPANY_STATUS_CHANGE,
  ],
  [FilterKeys.TRANSFER]: [
    TransactionType.AUTOIMPORT,
    TransactionType.BUY_SELL,
    TransactionType.INHERITANCE,
    TransactionType.GIFT,
    TransactionType.OTHER_TRANSFER,
  ],
  [FilterKeys.ISSUE]: [TransactionType.ISSUE, TransactionType.INCREASE_NOMINAL_VALUE],
  [FilterKeys.SPLIT]: [TransactionType.SPLIT, TransactionType.REVERSE_SPLIT],
  [FilterKeys.CAPITAL_REDUCTION]: [
    TransactionType.REDUCTION_NOMINAL_VALUE,
    TransactionType.CANCELLATION_OF_SHARES,
  ],
  [FilterKeys.DIVIDEND]: [TransactionType.PAY_DIVIDEND, TransactionType.GROUP_CONTRIBUTION],
};
